export const MODAL_ADD_EXISTING_CONTACT = 'add-existing-contact';
export const MODAL_ADD_NEW_CONTACT = 'add-new-contact';
export const MODAL_ADD_INSPIRATION = 'add-inspiration';
export const MODAL_ADD_SHOPPING_ITEM = 'add-shopping-item';